import React, { FC } from 'react'

import { ActionButtonProps } from '../ActionButton'
import ContentCard, { ContentCardProps } from '../ContentCard'

import * as SC from './styled'

export type RecipeCardListProps = {
  items: ContentCardProps[]
  loadMoreButtonProps?: ActionButtonProps
  loadPreviousButtonProps?: ActionButtonProps
  noResults?: string
}

const RecipeCardList: FC<RecipeCardListProps> = (props) => {
  const {
    items,
    loadPreviousButtonProps,
    loadMoreButtonProps,
    noResults,
  } = props

  return (
    <SC.RecipeCardListWrapper>
      {loadPreviousButtonProps && (
        <SC.PreviousRecipe {...loadPreviousButtonProps} />
      )}
      <SC.RecipeCardListGrid>
        {items.map((card) => {
          return <ContentCard key={card?.id} {...card} />
        })}
      </SC.RecipeCardListGrid>
      {!items?.length && noResults && <SC.NoResults>{noResults}</SC.NoResults>}
      {loadMoreButtonProps && <SC.MoreRecipe {...loadMoreButtonProps} />}
    </SC.RecipeCardListWrapper>
  )
}

export default RecipeCardList
